import { useParams } from "react-router-dom";

import { DashboardCard2 } from "@/components/layout/DashboardCard2";
import type { UUID } from "@/core/types";
import { ViewContent2 } from "@/components/layout/ViewContent";

import { DraftNotesTable } from "./components/DraftNotesTable";
import { useDraftNotes } from "./api/queries/useDraftNotes";

export function DraftNotes() {
  const { providerId } = useParams<{ providerId?: UUID }>();
  const { data = [], isLoading } = useDraftNotes(providerId);

  return (
    <ViewContent2>
      <div data-public="true">
        <DashboardCard2 isFullBleed title="Draft Notes">
          <DraftNotesTable isLoading={isLoading} rows={data} />
        </DashboardCard2>
      </div>
    </ViewContent2>
  );
}
